import { defineMessages } from 'react-intl';

export const ErrorFallbackMessages = defineMessages({
  RequestError: {
    id: 'so-errorFallback-message',
    defaultMessage:
      'Aus technischen Gründen ist die Musterbestellung momentan nicht möglich. Bitte lade die Seite erneut oder versuche es später noch einmal.',
  },
});
